import { ConfigCatProvider } from 'configcat-react';
import React from 'react';

interface Props {
	children: React.ReactNode;
	sdkKey?: string;
}

// Docs: https://configcat.com/docs/sdk-reference/react/
export const ConfigCatWrapper = ({ children, sdkKey }: Props): React.ReactElement => {
	if (!sdkKey) {
		return children as React.ReactElement;
	}

	return <ConfigCatProvider sdkKey={sdkKey}>{children}</ConfigCatProvider>;
};
